import React, { useEffect } from "react";
import { UseFormRegister, FieldErrors, UseFormSetValue, UseFormWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputField from "../../form/InputField";
import { PermissionsKey } from "../../../data/permissions";
import PermissionLable from "../../ui/PermissionLable";

export interface RoleFormData {
  title: string;
  permissions: PermissionsKey[];
}

interface Props {
  register: UseFormRegister<RoleFormData>;
  errors: FieldErrors<RoleFormData>;
  setValue: UseFormSetValue<RoleFormData>; // مهم
  defaultValues?: RoleFormData;
  watch: any; // نستخدمه لمراقبة تغييرات الحقول
}

const allPermissions = Object.values(PermissionsKey);

const RoleForm: React.FC<Props> = ({ register, errors, setValue, defaultValues, watch }) => {
  const { t } = useTranslation();

  const selectedPermissions: PermissionsKey[] = watch("permissions") || [];

  // إذا كل الصلاحيات محددة، Select All تكون محددة
  const selectAll = selectedPermissions.length === allPermissions.length;

  const handleSelectAllChange = (checked: boolean) => {
    setValue("permissions", checked ? allPermissions : []);
  };

  return (
    <div className="grid gap-4">
      <InputField
        placeholder=""
        label={t("role_title")}
        defaultValue={defaultValues?.title}
        register={register("title", { required: t("required_field") })}
        error={errors.title}
      />

      <div className="flex flex-col gap-2">
        <label className="font-semibold text-Black">{t("permissions")}</label>

        {/* Select All */}
        <label className="flex items-center gap-2 mb-2">
          <input
            type="checkbox"
            checked={selectAll}
            onChange={(e) => handleSelectAllChange(e.target.checked)}
          />
          {t("select_all")}
        </label>

        <div className="grid md:grid-cols-4 gap-2 max-h-96 overflow-auto border p-2 rounded">
          {allPermissions.map((permission,index) => (
            <label key={permission+index} className="flex items-center gap-2">
              <input
                type="checkbox"
                value={permission}
                {...register("permissions")}
                defaultChecked={defaultValues?.permissions?.includes(permission)}
              />
              <PermissionLable label={permission}/>
            </label>
          ))}
        </div>

        {errors.permissions && (
          <p className="text-danger text-sm">{errors.permissions.message}</p>
        )}
      </div>
    </div>
  );
};

export default RoleForm;
